import React from 'react';
import Icon from '../../../components/AppIcon';

const DesktopTabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-white/70 backdrop-blur-sm rounded-lg shadow-lg border border-blue-100">
      <div className="p-2">
        <nav className="space-y-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 text-left rounded-lg font-medium transition-all duration-200 ${
                tab.id === activeTab
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-slate-600 hover:text-slate-800 hover:bg-blue-50'
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-200 ${
                tab.id === activeTab 
                  ? 'bg-white/20' :'bg-slate-200'
              }`}>
                <Icon 
                  name={tab.icon} 
                  size={16} 
                  className={tab.id === activeTab ? 'text-white' : 'text-slate-600'} 
                />
              </div>
              
              <div className="flex-1">
                <span className="block text-sm">{tab.label}</span>
                {tab.description && (
                  <span className={`block text-xs mt-0.5 ${
                    tab.id === activeTab ? 'text-white/80' : 'text-slate-500'
                  }`}>
                    {tab.description}
                  </span>
                )}
              </div>
              
              {tab.id === activeTab && (
                <Icon name="ChevronRight" size={16} className="text-white" />
              )}
            </button>
          ))}
        </nav>
      </div>
      
      {/* Navigation Footer */}
      <div className="border-t border-blue-100 p-4">
        <div className="flex items-center space-x-3 text-sm text-slate-600">
          <Icon name="Shield" size={16} className="text-blue-600" />
          <div>
            <p className="font-medium">Your Data is Secure</p>
            <p className="text-xs">End-to-end encrypted wellness data</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopTabNavigation;